module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "context"
  }, [_vm._t("context")], 2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._t("actions")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-98928650!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/post-block.vue
// module id = 2109
// module chunks = 2